import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    accountId: String,
    projectId: String
  }

  openLightbox(event) {
    event.preventDefault()

    const lightboxData = JSON.parse(event.currentTarget.dataset.lightbox || "{}")
    const index = parseInt(event.currentTarget.dataset.index, 10) || 0

    // Collect all lightbox-enabled items
    const allItems = this.element.querySelectorAll("[data-lightbox]")
    const assets = Array.from(allItems).map(el => JSON.parse(el.dataset.lightbox))

    // Find the lightbox dialog
    const lightbox = document.querySelector("[data-controller='asset-lightbox']")
    if (!lightbox) return

    // Dispatch custom event to open lightbox
    lightbox.dispatchEvent(new CustomEvent("lightbox:open", {
      detail: { assets, index }
    }))
  }
}
